import React from 'react';

export default function Checkbox({
  label,
  labelProps = {},
  checked,
  onChange,
  inputProps = {},
  ...props
}) {
  if (
    labelProps &&
    labelProps.className &&
    labelProps.className.indexOf('cursor-pointer') === -1
  ) {
    labelProps = { ...labelProps, className: labelProps.className + ' cursor-pointer' };
  } else {
    labelProps = { className: 'cursor-pointer' };
  }

  return (
    <div className="block mt-2" {...props}>
      <label {...labelProps}>
        <input
          type="checkbox"
          className="-mt-1 rounded bg-giveGray-100 accent-brand-200 outline-giveRed-300 checked:bg-brand-200 border-giveGray-300 border-solid text-mint-600 shadow-sm focus:border-mint-600 focus:ring focus:ring-offset-0 focus:ring-mint-600 focus:ring-opacity-25"
          checked={checked}
          onChange={onChange}
          {...inputProps}
        />
        &nbsp; {label}
      </label>
    </div>
  );
}
